module.exports = __webpack_public_path__ + "img/img-prod-commerce.7773e62e.png";